const logs = {
  loki: {
    url: process.env.LOKI_URL!,
    username: process.env.LOKI_USERNAME!,
    password: process.env.LOKI_PASSWORD!,
  },
};

export default logs;
